import { create } from 'zustand';

function getTodayValue() {
  return new Date().toISOString().slice(0, 10);
}

const initialFilters = {
  tipoOperativo: '',
  operativo: '',
  lugarOperativo: '',
  date: getTodayValue(),
  turno: '',
};

const initialState = {
  filters: initialFilters,
  hasSearchedOperarios: false,
  operariosDisponibles: [],
  operarioSearch: '',
  operariosSeleccionados: [],
};

export const useAmarreStore = create((set) => ({
  ...initialState,
  setTipoOperativo(tipoOperativo) {
    set((state) => ({
      filters: {
        ...state.filters,
        tipoOperativo,
        operativo: '',
        lugarOperativo: '',
      },
      hasSearchedOperarios: false,
      operariosDisponibles: [],
      operarioSearch: '',
      operariosSeleccionados: [],
    }));
  },
  setOperativo(operativo) {
    set((state) => ({
      filters: {
        ...state.filters,
        operativo,
        lugarOperativo: '',
      },
      hasSearchedOperarios: false,
      operariosDisponibles: [],
      operarioSearch: '',
      operariosSeleccionados: [],
    }));
  },
  setLugarOperativo(lugarOperativo) {
    set((state) => ({
      filters: {
        ...state.filters,
        lugarOperativo,
      },
    }));
  },
  setDate(date) {
    set((state) => ({
      filters: {
        ...state.filters,
        date,
      },
    }));
  },
  setTurno(turno) {
    set((state) => ({
      filters: {
        ...state.filters,
        turno,
      },
    }));
  },
  buscarOperarios(operariosDisponibles = []) {
    set({
      hasSearchedOperarios: true,
      operariosDisponibles,
      operarioSearch: '',
      operariosSeleccionados: operariosDisponibles,
    });
  },
  volverAFiltros() {
    set({
      hasSearchedOperarios: false,
      operarioSearch: '',
      operariosSeleccionados: [],
    });
  },
  setOperarioSearch(operarioSearch) {
    set({ operarioSearch });
  },
  toggleOperario(operario) {
    set((state) => {
      const alreadySelected = state.operariosSeleccionados.some(
        (item) => item.id === operario.id
      );

      return {
        operariosSeleccionados: alreadySelected
          ? state.operariosSeleccionados.filter((item) => item.id !== operario.id)
          : [...state.operariosSeleccionados, operario],
      };
    });
  },
  resetAmarre() {
    set({
      ...initialState,
      filters: {
        ...initialFilters,
        date: getTodayValue(),
      },
    });
  },
}));
